import { SiteLink } from "@i18n/SiteLink";
import {
	formatUsd,
	perplexityFromMonthly,
} from "@saas/payments/lib/pricing-v2";
import { cn } from "@ui/lib";
import { ArrowRightIcon } from "lucide-react";
import { useTranslations } from "next-intl";

/**
 * One compact card pointing at /pricing/add-ons: Perplexity from its lowest
 * monthly price, Claude on request. Used on the pricing page and in-app.
 */
export function AddOnsTeaser({
	href = "/pricing/add-ons",
	className,
}: {
	href?: string;
	className?: string;
}) {
	const t = useTranslations();
	const from = perplexityFromMonthly();
	return (
		<div
			className={cn(
				"flex flex-col gap-5 rounded-2xl border bg-card p-6 sm:flex-row sm:items-center sm:justify-between",
				className,
			)}
		>
			<div className="flex items-start gap-4">
				<div className="flex shrink-0 -space-x-2" aria-hidden>
					<PlatformLogo src="/images/perplexity-logo.svg" />
					<PlatformLogo src="/images/claude-logo.svg" />
				</div>
				<div>
					<h3 className="font-bold tracking-tight">
						{t("pricing.v2.addOnsTeaser.title")}
					</h3>
					<p className="mt-1 text-sm text-muted-foreground">
						{from === null
							? t("pricing.v2.addOnsTeaser.perplexity")
							: t("pricing.v2.addOnsTeaser.perplexityFrom", {
									price: formatUsd(from),
								})}{" "}
						{t("pricing.v2.addOnsTeaser.claude")}
					</p>
				</div>
			</div>
			<SiteLink
				href={href}
				className="inline-flex shrink-0 items-center gap-1 text-sm font-bold text-primary hover:underline"
			>
				{t("pricing.v2.addOnsTeaser.link")}
				<ArrowRightIcon className="size-3.5" aria-hidden />
			</SiteLink>
		</div>
	);
}

function PlatformLogo({ src }: { src: string }) {
	return (
		<span className="flex size-9 items-center justify-center rounded-full border bg-white ring-2 ring-card">
			{/* eslint-disable-next-line @next/next/no-img-element */}
			<img src={src} alt="" className="size-5 object-contain" />
		</span>
	);
}
